export default __webpack_public_path__ + "static/media/zoznam-biele.34dd0dea.svg";